import styled from 'styled-components'
import { H3 } from 'components/Typography'
import theme from 'theme_'

export const AvailableLicensesContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 128px;
`

export const AvailableLicensesHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`

export const Title = styled.div`
  font-weight: 900;
  font-size: 20px;
  line-height: 32px;
`

export const StyledInfo = styled(H3)`
  text-align: center;
  color: ${theme.colors.disabledGrey};
`
